module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-f4101e3c.png";